// 用于校验图片参数
function getCheckConfigs() {
  /**
   * text 格式图片校验
   *
   * @param {boolean} hasCombin - 是否有独立跟随
   */
  const textCheck = (hasCombin = false, checkInvalidImage = false) => {
    const checkArr = hasCombin
      ? [
          {
            fieldPath: ['text', 'image', 'font_images', 0, 'images'],
            isList: true,
            // workaround 这块结构待优化以适应多条件组合场景
            when: [
              {
                fieldPath: ['combin'],
                value: 'single'
              },
              {
                fieldPath: ['text', 'image', 'system_font'],
                value: undefined // 当该路径无值时进行校验
              }
            ]
          }
        ]
      : [
          {
            fieldPath: ['text', 'image', 'font_images', 0, 'images'],
            isList: true,
            when: {
              fieldPath: ['text', 'image', 'system_font'],
              value: undefined // 当该路径无值时进行校验
            }
          }
        ]
    if (checkInvalidImage) {
      checkArr.push({
        fieldPath: ['text', 'image', 'invalid_image']
      })
    }

    return checkArr
  }

  // const progressCheck = [
  //     {
  //         fieldPath: ['progress_image'],
  //         when: {
  //             fieldPath: ['progress_render_type'],
  //             value: 'image',
  //         },
  //     },
  // ];

  const pointerProgressCheck = [
    {
      fieldPath: ['pointer', 'image']
    }
  ]

  const pointImageCheck = [
    {
      fieldPath: ['text', 'image', 'point_image', 'url']
    }
  ]

  const checkConfigs = {
    common: {
      // text
      current: textCheck(),
      target: textCheck(),
      text: textCheck(),
      // 图标
      icon: [
        {
          fieldPath: ['image']
        }
      ],
      // 常规进度
      // progress: progressCheck,
      pointer_progress: pointerProgressCheck,
      image_progress: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ]
    },
    date: {
      year: textCheck(),
      month: textCheck(true),
      day: textCheck(true)
    },
    week: {
      text: [
        {
          fieldPath: ['text', 'image', 'font_images', 0, 'images']
        }
      ]
    },
    // progress_clock: {
    //     hour: progressCheck,
    //     minute: progressCheck,
    //     second: progressCheck,
    // },
    digital_clock: {
      hour: textCheck(),
      minute: textCheck(true),
      second: textCheck(true),
      am: [
        {
          fieldPath: ['images', '0', 'image', 'url']
        },
        {
          fieldPath: ['images', '1', 'image', 'url']
        }
      ],
      pm: [
        {
          fieldPath: ['images', '0', 'image', 'url']
        },
        {
          fieldPath: ['images', '1', 'image', 'url']
        }
      ]
    },
    heart_rate: {
      text: textCheck(false, true)
    },
    distance: {
      text: [
        {
          fieldPath: ['text', 'image', 'point_image', 'url']
        }
      ]
    },
    stand: {
      text: [
        {
          fieldPath: ['text', 'image', 'point_image', 'url']
        }
      ],
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 12,
          isList: true
        }
      ]
    },
    moon: {
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 30,
          isList: true
        }
      ]
    },
    moon_rise: {
      text: textCheck().concat(pointImageCheck)
    },
    moon_set: {
      text: textCheck().concat(pointImageCheck)
    },
    system: {
      dnd: [
        {
          fieldPath: ['image']
        }
      ],
      lock: [
        {
          fieldPath: ['image']
        }
      ],
      clock: [
        {
          fieldPath: ['image']
        }
      ],
      disconnect: [
        {
          fieldPath: ['image']
        }
      ]
    },
    background: [
      {
        fieldPath: ['image'],
        when: {
          fieldPath: ['bg_type'],
          value: 'image'
        }
      },
      {
        fieldPath: ['editable_bg', 'bg_images'],
        isList: true,
        when: {
          fieldPath: ['bg_type'],
          value: 'editable_bg'
        }
      },
      {
        fieldPath: ['editable_bg', 'tip_image'],
        when: {
          fieldPath: ['bg_type'],
          value: 'editable_bg'
        }
      },
      {
        fieldPath: ['editable_bg', 'fg_image'],
        when: {
          fieldPath: ['bg_type'],
          value: 'editable_bg'
        }
      }
    ],
    scale: [
      {
        fieldPath: ['image']
      }
    ],
    analog_clock: {
      hour: [
        {
          fieldPath: ['pointer', 'image']
        }
      ],
      minute: [
        {
          fieldPath: ['pointer', 'image']
        }
      ],
      second: [
        {
          fieldPath: ['pointer', 'image']
        }
      ]
    },
    weather: {
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 29,
          isList: true
        }
      ]
    },
    temperature: {
      current: textCheck(false, true).concat([
        {
          fieldPath: ['text', 'image', 'negative_image', 'url']
        }
      ]),
      high: textCheck(false, true).concat([
        {
          fieldPath: ['text', 'image', 'negative_image', 'url']
        }
      ]),
      low: textCheck(true, true).concat([
        {
          fieldPath: ['text', 'image', 'negative_image', 'url']
        }
      ])
    },
    sun: {
      current: textCheck(false, true),
      high: textCheck(),
      low: textCheck(),
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 2,
          isList: true
        }
      ]
    },
    pai: {
      weekly: textCheck()
    },
    pai_daily: {
      daily: textCheck()
    },
    aqi: {
      text: textCheck(false, true),
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 6,
          isList: true
        }
      ]
    },
    uvi: {
      text: textCheck(false, true),
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 5,
          isList: true
        }
      ]
    },
    altimeter: {
      text: textCheck(false, true)
    },
    wind: {
      text: textCheck(false, true),
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 12,
          isList: true
        }
      ]
    },
    stress: {
      text: textCheck(false, true)
    },
    spo2: {
      text: textCheck(false, true)
    },
    humidity: {
      text: textCheck(false, true)
    },
    hrv: {
      text: textCheck(false, true)
    },
    recovery_time: {
      text: textCheck(false, true)
    },
    sleep: {
      text: textCheck(false, true).concat(pointImageCheck)
    },
    altitude: {
      text: textCheck(false, true)
    },
    bio_charge: {
      text: textCheck(false, true)
    },
    lthr: {
      text: textCheck(false, true)
    },
    ltpace: {
      text: textCheck(false, true).concat(pointImageCheck)
    },
    month_run_times: {
      text: textCheck()
    },
    month_run_distance: {
      text: textCheck().concat(pointImageCheck)
    },
    floor: {
      text: textCheck()
    },
    mask: [
      {
        fieldPath: ['cover']
      },
      {
        fieldPath: ['mask']
      }
    ],
    animation: {
      first: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ],
      second: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ],
      third: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ]
    },
    editable_bg: {
      bg: [
        {
          fieldPath: ['bg_images'],
          isList: true
        }
      ]
    }
  }

  return checkConfigs
}

export default getCheckConfigs
